import React, { useEffect } from 'react';
import styles from './AboutUs2.module.css';

const AboutUs2 = () => {
  useEffect(() => {
    const setVhProperty = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVhProperty();
    window.addEventListener('resize', setVhProperty);
    window.addEventListener('orientationchange', setVhProperty);

    return () => {
      window.removeEventListener('resize', setVhProperty);
      window.removeEventListener('orientationchange', setVhProperty);
    };
  }, []);

  return (
    <section className={styles.aboutUs2}>
      <div className={styles.columnRight}>
        <h1 className={styles.orangeTitle}>Our Mission</h1>
        <h1 className={styles.blackTitle}>Making the world a less lonely place</h1>
        <h2 className={styles.subtitle}>one match at a time</h2>
      </div>
      <div className={styles.columnLeft}>
        <h1 className={styles.orangeTitle}>Our Vision</h1>
        <h1 className={styles.blackTitle}>Redesign online dating</h1>
        <h2 className={styles.subtitle}>to include the human component</h2>
      </div>
    </section>
  );
};

export default AboutUs2;
